import {Directive, ViewContainerRef, TemplateRef} from '@angular/core';
import {isBlank} from '../facade/lang';
export class NgIf {
  private _prevCondition: boolean = null;

  constructor(private _viewContainer: ViewContainerRef, private _templateRef: TemplateRef<Object>) {
  }

  set ngIf(newCondition: any /* boolean */) {
    if (newCondition && (isBlank(this._prevCondition) || !this._prevCondition)) {
      this._prevCondition = true;
      this._viewContainer.createEmbeddedView(this._templateRef);
    } else if (!newCondition && (isBlank(this._prevCondition) || this._prevCondition)) {
      this._prevCondition = false;
      this._viewContainer.clear();
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{selector: '[ngIf]', inputs: ['ngIf']}, ] },
];
static ctorParameters: {type: Function, decorators?: DecoratorInvocation[]}[] = [
{type: ViewContainerRef, },
{type: TemplateRef, },
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
